import React from 'react';

export default function StatCard({ label, value, highlight = false }) {
  return (
    <div style={{
      padding: '20px',
      borderRadius: 'var(--radius-md)',
      background: highlight
        ? 'linear-gradient(135deg, rgba(80, 220, 120, 0.12), rgba(80, 220, 120, 0.04))'
        : 'var(--bg-surface)',
      border: highlight
        ? '1px solid rgba(80, 220, 120, 0.2)'
        : '1px solid var(--border-color)',
    }}>
      <div style={{ color: 'var(--text-muted)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: '8px' }}>{label}</div>
      <div style={{ color: highlight ? '#50dc78' : 'var(--text-main)', fontSize: '28px', fontWeight: 700 }}>{value}</div>
    </div>
  );
}
